export function WorkerNavigationMenuItemsContainer() {
  return <div>PLACEHOLDER</div>;
}
